// This file is AUTOGENERATED, do not edit it manually!!!

export const portfolios = {
    add_portfolio: 'Agregar portafolio',
    add_sub_portfolio: 'Agregar subportafolio',
    copy_custom_fields_label: 'Copiar campos personalizados del portafolio principal',
    delete_portfolio_title: '¿Eliminar portafolio \"{0}\"?',
    DeletionIsUsedDisabled: 'El estatus no se puede eliminar ya que existe un portafolio con este estatus.',
    Editor: 'Editor de portafolio',
    Manager: 'Gestor de portafolio',
    members: '1#{0} miembro del portafolio#{0} miembros del portafolio',
    new_portfolio: 'Nuevo portafolio',
    NewStatusTitle: 'Agregar estatus',
    ParentPortfolio: 'Portafolio principal',
    permissions_title: 'Este nivel de acceso tiene los siguientes permisos con respecto al portafolio y los proyectos en él',
    Portfolios: 'Portafolios',
    role_for_this_portfolio: 'Nivel de acceso para este portafolio:',
    Statuses: 'Estatus',
    Teamer: 'Participante del portafolio',
    Viewer: 'Visualizador de portafolio',
};
